import { Button, Center, CopyButton, Paper, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IncidentButton } from './Incident';
import { IconBrowser, IconCheck, IconCopy } from '@tabler/icons-react';

// Встроенные браузеры мессенджеров ломают вход через SSO и Google (раздел 2.1, T-22)
export function isInAppBrowser(): boolean {
  const ua = navigator.userAgent;
  const w = window as unknown as Record<string, unknown>;
  if (w.TelegramWebviewProxy || w.TelegramWebview) return true;
  return /Telegram|WhatsApp|Instagram|FBAN|FBAV|FB_IAB|Line\/|VKClient|MicroMessenger|; wv\)/i.test(ua);
}

export function InAppBrowserPage() {
  const url = location.href;
  return (
    <Center mih="100vh" p="md">
      <Paper withBorder shadow="sm" radius="lg" p="xl" maw={440} w="100%">
        <Stack align="center" ta="center" gap="md">
          <ThemeIcon size={64} radius="xl" variant="light"><IconBrowser size={36} /></ThemeIcon>
          <Title order={3}>Откройте в обычном браузере</Title>
          <Text c="dimmed" size="sm">Во встроенном браузере мессенджера вход через корпоративную учётную запись не работает. Скопируйте ссылку и откройте её в Chrome, Safari, Edge или Firefox.</Text>
          <Text size="sm" fw={500} style={{ wordBreak: 'break-all' }}>{url}</Text>
          <CopyButton value={url}>
            {({ copied, copy }) => (
              <Button fullWidth size="md" color={copied ? 'teal' : 'blue'} leftSection={copied ? <IconCheck size={18} /> : <IconCopy size={18} />} onClick={copy}>
                {copied ? 'Ссылка скопирована' : 'Скопировать ссылку'}
              </Button>
            )}
          </CopyButton>
          <IncidentButton authed={false} />
        </Stack>
      </Paper>
    </Center>
  );
}
